<router-outlet></router-outlet>
<app-claim-printer></app-claim-printer>
